const baseColorMap = {
    'Black': '#f3f3f3',
    'Blue': '#d3e6fa',
    'Pink': '#fdd2e5',
    'Purple': '#e4c9e7',
    'Mint': '#e1eff1',
    'Sage': '#dfe7de',
    'Sand': '#f9ebe1'
};

const secondaryColorMap = {
    'Black': '#fff',
    'Blue': '#8ec6ff',
    'Pink': '#fba0c8',
    'Purple': '#cfa2d4',
    'Mint': '#ace8f1',
    'Sage': '#b8cbb8',
    'Sand': '#e7cbb1'
};

const productSection = document.querySelector('.product-section');
const featureSection = document.querySelector('.product-features');
const overlay = document.getElementById('transitionOverlay');
const transWave = document.getElementById('transitionWave');
const topWave = document.getElementById('topWave');

let isTransitioning = false;
let transitionTimeout; // For managing the timeout
let resetTimeout;      // For managing the reset

document.addEventListener('DOMContentLoaded', function() {
    const selectedVariantInput = document.querySelector('.variant-wrapper.js input[type="radio"]:checked');
  
    if (selectedVariantInput) {
        const selectedColor = selectedVariantInput.value;
        const baseColor = baseColorMap[selectedColor];
        const secondaryColor = secondaryColorMap[selectedColor];
        
        if (productSection) productSection.style.backgroundColor = baseColor;
        if (topWave) topWave.style.fill = secondaryColor;
        if (featureSection) featureSection.style.backgroundColor = secondaryColor;
    }

    // Handle Notify Me form submission via iframe
    document.querySelectorAll('.notify-form').forEach(form => {
        form.addEventListener('submit', function(event) {
            const submitButton = form.querySelector('.notify-btn');
            const messageContainer = form.querySelector('.notify-form__message');

            // Disable the button to prevent multiple submissions
            submitButton.disabled = true;
            submitButton.textContent = 'Submitting...';

            // Clear any previous message
            messageContainer.style.display = 'none';
            messageContainer.textContent = '';
        });
    });

    // Detect iframe load and always assume success
    document.querySelectorAll('[data-notify-iframe]').forEach(iframe => {
        iframe.addEventListener('load', function() {
            const form = document.querySelector(`form[target="${iframe.name}"]`);
            if (!form) return;

            const messageContainer = form.querySelector('.notify-form__message');
            const submitButton = form.querySelector('.notify-btn');

            // Always show success message
            messageContainer.textContent = 'Thank you! We’ll notify you when this item is back in stock.';
            messageContainer.classList.add('success');
            messageContainer.classList.remove('error');
            messageContainer.style.display = 'block';
            // Hide the form inputs
            form.querySelector('.notify-form__inner').style.display = 'none';
            form.querySelector('.notify-me-message').style.display = 'none';
        });
    });
});

document.addEventListener('variant:change', function(evt) {
    const variant = evt.detail.variant;
    const variantColorName = variant.title;
    const baseColor = baseColorMap[variantColorName];
    const secondaryColor = secondaryColorMap[variantColorName];

    // Clear any existing timeouts to avoid overlapping transitions
    clearTimeout(transitionTimeout);
    clearTimeout(resetTimeout);

    // If a transition is ongoing, reset the overlay without a transition
    if (isTransitioning) {
        overlay.style.transition = 'none';
        overlay.style.left = '-100%';
        overlay.style.opacity = '0';  // Fade out

        // Restore the transition property after a brief delay
        setTimeout(() => {
            overlay.style.transition = 'left 0.75s ease-in-out, opacity 0.2s ease-in-out';
        }, 10);
    }

    if (overlay) overlay.style.backgroundColor = baseColor;
    if (transWave) transWave.style.fill = baseColor;
    if (topWave) topWave.style.fill = secondaryColor;
    if (featureSection) featureSection.style.backgroundColor = secondaryColor;

    // Start the new transition
    transitionTimeout = setTimeout(() => {
        isTransitioning = true;
        overlay.style.opacity = '1';
        overlay.style.left = '0';
    }, 10);

    // After the transition completes, set the .product-section's background color
    // and reset the overlay off to the left without a transition
    resetTimeout = setTimeout(() => {
        if (productSection) productSection.style.backgroundColor = baseColor;
        overlay.style.transition = 'none';
        overlay.style.left = '-100%';
        overlay.style.opacity = '0';  // Fade out

        // Restore the transition property after a brief delay
        setTimeout(() => {
            overlay.style.transition = 'left 0.75s ease-in-out, opacity 0.2s ease-in-out';
            isTransitioning = false;
        }, 10);
    }, 750);

    // Notify Me wrapper visibility handling
    document.querySelectorAll('.notify-me-wrapper').forEach(wrapper => {
        wrapper.style.display = 'none';
        if (!variant.available && wrapper.getAttribute('id') === `notify-wrapper-${variant.id}`) {
            wrapper.style.display = 'block';
        }
    });
});